var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-model"},[_c('div',{staticClass:"model"},[(_vm.loadingVoice)?_c('div',{staticClass:"guanbi",on:{"click":_vm.closedFn}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":require("../../../static/img/loading.gif")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56875aef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadingComponent/loading.vue
// module id = null
// module chunks = 